// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B298iXnVkX76Xh {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.aaPtEisUDPh4fP {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.B9i8o8eqasp3TC {
  padding: var(--ds-space-400, 32px) 140px var(--ds-space-500, 40px) 140px;
  text-align: center;
}
.JHqe8LcxzvZPOV {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.put0vTviM4_zTc {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.put0vTviM4_zTc:hover,
.put0vTviM4_zTc:active {
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gaAnnouncementModal": `B298iXnVkX76Xh`,
	"headingImage": `aaPtEisUDPh4fP`,
	"contentContainer": `B9i8o8eqasp3TC`,
	"ctasContainer": `JHqe8LcxzvZPOV`,
	"closeButton": `put0vTviM4_zTc`
};
export default ___CSS_LOADER_EXPORT___;
